import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { NumberFormatTextPDF } from "../NumberFormatText";
import { tableDataTableStyles } from "./DataTable";

export function DataTableFHWAFooter({ data }) {
  const { t } = useTranslation("translation");
  let decimalSeparator = i18n.resolvedLanguage === "de-DE" ? "," : ".";
  let thousandSeparator = i18n.resolvedLanguage === "de-DE" ? "." : ",";
  return (
    <>
      <View style={tableDataTableStyles.row}>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        {/* Total */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("aashto.inner.Total")}</Text>
        <Text style={tableDataTableStyles.title_fhwa}>
          <NumberFormatTextPDF
            value={Number(data.tableTotal.current)}
            decimalScale={2}
            decimalSeparator={decimalSeparator}
            thousandSeparator={thousandSeparator}
          />
        </Text>
      </View>
      <View style={tableDataTableStyles.row}>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        <Text style={tableDataTableStyles.title_fhwa}></Text>
        {/* Utilization */}
        <Text style={tableDataTableStyles.title_fhwa}>{t("aashto.inner.Utilization")}</Text>
        <Text style={tableDataTableStyles.title_fhwa}>
          <NumberFormatTextPDF
            value={data.tableUtilization}
            decimalScale={2}
            decimalSeparator={decimalSeparator}
            thousandSeparator={thousandSeparator}
          />
        </Text>
      </View>
    </>
  );
}
